import React from "react"

import { FeedbackType } from "shared/types/FeedbackType"

import { FeedbackAttachment } from "features/feedback/model/useFeedback"

import { FeedbackOverlay } from "./FeedbackOverlay"
import { useFeedbackOverlayModel } from "./hooks/useFeedbackOverlayModel"

export interface FeedbackOverlayPayload {
  feedbackType: FeedbackType
  message?: string
  attachments?: FeedbackAttachment[]
}

export interface FeedbackOverlayConnectorProps {
  payload: FeedbackOverlayPayload
}

export const FeedbackOverlayConnector = React.memo(
  (props: FeedbackOverlayConnectorProps) => (
    <FeedbackOverlay {...useFeedbackOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    FEEDBACK_OVERLAY: FeedbackOverlayPayload
  }
}
